import React, {useCallback, useState} from "react";
import "./index.scss";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import {connect} from "react-redux";
import {getCompaniesStart, newCompany, resetUpsertCompany, upsertCompanyStart} from "store/reducer/company/reducer";
import {
    isEditingCompany,
    myCompaniesLoading,
    myCompaniesSelector,
    selectedCompanyForUpsert, upsertCompanyError, upsertCompanyLoading
} from "store/reducer/company/selectors";
import Loading from "features/components/loading";
import Button from "features/components/button";
import {showAssociateModal} from "features/modals/company/associate/reducer";
import AssociateCompanyModal from "features/modals/company/associate";
import {shouldShowAssociateModal} from "features/modals/company/associate/selectors";
import CompanyInfo from "features/components/company-info";
import DisassociateCompanyModal from "features/modals/company/disassociate";
import {shouldShowDisassociateModal} from "features/modals/company/disassociate/selectors";
import CompanyUpsertForm from "features/forms/company-upsert";
import {shouldShowDisassociateUserModal} from "features/modals/company/disassociate-user/selectors";
import DisassociateUserModal from "features/modals/company/disassociate-user";

/* istanbul ignore next */
const mapStateToProps = state => ({
    get_loading: myCompaniesLoading(state),
    data: myCompaniesSelector(state),
    shouldShowAssociateModal: shouldShowAssociateModal(state),
    shouldShowDisassociateModal: shouldShowDisassociateModal(state),
    isEditingCompany: isEditingCompany(state),
    selectedUpsertCompany: selectedCompanyForUpsert(state),
    upsert: {
        loading: upsertCompanyLoading(state),
        error: upsertCompanyError(state)
    },
    shouldShowDisassociateUserModal: shouldShowDisassociateUserModal(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    getCompaniesStart,
    showAssociateModal,
    newCompany,
    resetUpsertCompany,
    upsertCompanyStart
};


export const CompanyEdit = (props) => {
    const {getCompaniesStart, get_loading, data, showAssociateModal,
        shouldShowAssociateModal,
        shouldShowDisassociateModal, isEditingCompany, newCompany, selectedUpsertCompany, resetUpsertCompany,
        upsertCompanyStart, upsert, shouldShowDisassociateUserModal} = props;

    React.useEffect(() => {
        getCompaniesStart();
    }, [getCompaniesStart]);

    const associateCompany = useCallback(() => {
        showAssociateModal();
    }, [showAssociateModal]);
    const newCompanyClick = useCallback(() => {
        newCompany()
    }, [newCompany]);

    const resetUpsertCompanyClick = useCallback(() => {
        resetUpsertCompany();
    }, [resetUpsertCompany]);

    const [selectedCompany, setSelectedCompany] = useState({});

    const saveSelectedCompanyClick = useCallback(() => {
        upsertCompanyStart(selectedCompany);
    }, [upsertCompanyStart, selectedCompany]);

    return <div className="edit-companies">
        {shouldShowAssociateModal && <AssociateCompanyModal/>}
        {shouldShowDisassociateModal && <DisassociateCompanyModal />}
        {shouldShowDisassociateUserModal && <DisassociateUserModal />}
        {
            !isEditingCompany ?
                <>
                    {get_loading ?
                        <Loading /> :
                        <div>
                            <Title size={18}>{data.length} {__(`common.associated-companies-${data.length === 1 ? "single" : "plural"}`)}</Title>
                            {
                                data.map(item => <CompanyInfo
                                    key={item.id}
                                    showValid={false}
                                    company={item}
                                    extended={true}
                                />)
                            }
                            <div className="buttons">
                                <Button title={__("buttons.associate-company")} onClick={associateCompany} type={"outlined"} icon={"link"} />
                                <Button title={__("buttons.new-company")} onClick={newCompanyClick} type={"outlined"} icon={"add-circle"} />
                            </div>
                        </div>
                    }
                </>
                :
                <>
                    <div className="row save-buttons">
                        <Button title={__("buttons.go-back")} type={"outlined"} onClick={resetUpsertCompanyClick} />
                        <Button title={__("buttons.save-data")} status={upsert.loading ? "loading" : "success"} disabled={!selectedCompany.valid} onClick={saveSelectedCompanyClick} />
                    </div>
                    <CompanyUpsertForm {...selectedUpsertCompany} onChange={setSelectedCompany} />
                    {upsert.error.inError && <Text size={16} color={"danger"}>{__(upsert.error.error)}</Text>}
                    <div className="row reverse">
                        <Button title={__("buttons.save-data")} status={upsert.loading ? "loading" : "success"} disabled={!selectedCompany.valid} onClick={saveSelectedCompanyClick} />
                    </div>
                </>
        }

    </div>
};

CompanyEdit.propTypes = {

};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyEdit);